import { create } from 'zustand'

interface NetworkStore {
  isOnline: boolean
  setOnline: (v: boolean) => void
}

export const useNetworkStore = create<NetworkStore>((set) => ({
  isOnline: navigator.onLine,
  setOnline: (isOnline) => set({ isOnline }),
}))
